"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var BaseHeader_styled_exports = {};
__export(BaseHeader_styled_exports, {
  StyledBaseHeaderContainer: () => StyledBaseHeaderContainer,
  StyledHeaderContent: () => StyledHeaderContent,
  StyledLogo: () => StyledLogo,
  StyledMenuContainer: () => StyledMenuContainer,
  StyledResponsiveLogo: () => StyledResponsiveLogo,
  StyledResponsiveLogoContainer: () => StyledResponsiveLogoContainer
});
module.exports = __toCommonJS(BaseHeader_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_mixins = require("../../../../themes/mixins");
var import_atoms = require("../../../atoms");
var StyledBaseHeaderContainer = import_styled_components.default.header.withConfig({
  displayName: "BaseHeaderstyled__StyledBaseHeaderContainer",
  componentId: "sc-1whynmj-0"
})(function(_ref) {
  var theme = _ref.theme;
  return (0, import_styled_components.css)(["display:flex;flex-direction:column;position:relative;width:100%;box-sizing:border-box;button{font-size:", ";cursor:pointer;}"], theme.typography.sizes.extraExtraLarge);
});
var StyledResponsiveLogoContainer = import_styled_components.default.div.withConfig({
  displayName: "BaseHeaderstyled__StyledResponsiveLogoContainer",
  componentId: "sc-1whynmj-1"
})(function(_ref2) {
  var theme = _ref2.theme;
  return (0, import_styled_components.css)(["background-color:", ";display:flex;justify-content:center;", ""], theme.colors.n[100], (0, import_mixins.mediaBreakpointUp)("lg", (0, import_styled_components.css)(["display:none;"])));
});
var StyledResponsiveLogo = (0, import_styled_components.default)(import_atoms.GreatMindsLogo).withConfig({
  displayName: "BaseHeaderstyled__StyledResponsiveLogo",
  componentId: "sc-1whynmj-2"
})(["height:32px;"]);
var StyledHeaderContent = import_styled_components.default.div.withConfig({
  displayName: "BaseHeaderstyled__StyledHeaderContent",
  componentId: "sc-1whynmj-3"
})(function(_ref3) {
  var theme = _ref3.theme;
  return (0, import_styled_components.css)(["display:flex;gap:", ";padding:", " ", ";align-items:center;", ""], theme.measurements.medium, theme.measurements.medium, theme.measurements.extraLarge, (0, import_mixins.mediaBreakpointUp)("md", (0, import_styled_components.css)(["gap:", ";"], theme.measurements.extraLarge)));
});
var StyledMenuContainer = import_styled_components.default.div.withConfig({
  displayName: "BaseHeaderstyled__StyledMenuContainer",
  componentId: "sc-1whynmj-4"
})(["display:flex;"]);
var StyledLogo = (0, import_styled_components.default)(import_atoms.GreatMindsLogo).withConfig({
  displayName: "BaseHeaderstyled__StyledLogo",
  componentId: "sc-1whynmj-5"
})(function() {
  return (0, import_styled_components.css)(["display:none;", ""], (0, import_mixins.mediaBreakpointUp)("lg", (0, import_styled_components.css)(["display:block;"])));
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledBaseHeaderContainer,
  StyledHeaderContent,
  StyledLogo,
  StyledMenuContainer,
  StyledResponsiveLogo,
  StyledResponsiveLogoContainer
});
//# sourceMappingURL=BaseHeader.styled.js.map